import { render, staticRenderFns } from "./journal-details.vue?vue&type=template&id=21731a5b&"
import script from "./journal-details.vue?vue&type=script&lang=js&"
export * from "./journal-details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports